import { useDispatch } from "react-redux";
import { Checkbox } from "@rmwc/checkbox";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import CurrencyFormat from "react-currency-format";
import EditPriceItem from "../../EditPriceItem/EditPriceItem";
import Popover from "react-bootstrap/Popover";
import { extraItemsAction, handleLoftChange } from "../../../action";
import { const_var, params } from "../../../redux/reducers/reducer";
import { Dropdown } from "react-bootstrap";
import React from "react";
import { Radio } from "@rmwc/radio";
const DropDefaultToggle = React.forwardRef(({ children, onClick }, ref) => (
	<a
		href=""
		className="drop-default-toggle"
		ref={ref}
		onClick={(e) => {
			e.preventDefault();
			onClick(e);
		}}
	>
		{children}
	</a>
));
const ExtraItemsAddOn = ({ elementPrice }) => {
	const dispatch = useDispatch();

	if (!(const_var.a_p_d_a.extra_add_on && const_var.a_p_d_a.extra_add_on.length > 0)) {
		return;
	}

	let isIncluded = false;
	let a_p_d_a = {...const_var.a_p_d_a};
	if (const_var.isLTBuilding) {
		if (const_var.selectedLeanType == "left") {
			a_p_d_a = structuredClone(const_var.leanGetDataLeft);
		} else if (const_var.selectedLeanType == "right") {
			a_p_d_a = structuredClone(const_var.leanGetDataRight);
		} else if (const_var.selectedLeanType == "front") {
			a_p_d_a = structuredClone(const_var.leanGetDataFront);
		} else if (const_var.selectedLeanType == "back") {
			a_p_d_a = structuredClone(const_var.leanGetDataBack);
		} else {
			a_p_d_a = structuredClone(const_var.holdPricingResponse);
		}
	}
	const onLoftChange = (value, index, label) => {
		let isFor = "center";
		if (const_var.isLTBuilding) {
			isFor = const_var.selectedLeanType === "" ? "center" : const_var.selectedLeanType;
		}
		dispatch(handleLoftChange(value, index, isFor, label));
	};

	const checkForVisiblity = () => {
		let leanType = const_var.selectedLeanType === "" ? "centerBuilding" : const_var.selectedLeanType;
		if (leanType == "left") {
			if (
				const_var.wallsData["leftLean"]?.closedEndWalls == 0 &&
				const_var.wallsData["leftLean"]?.closedSideWalls == 0 &&
				const_var.wallsData["leftLean"]?.fullclosedEndWalls == 0 &&
				const_var.wallsData["leftLean"]?.fullclosedSideWalls == 0
			) {
				return false;
			} else {
				return true;
			}
		} else if (leanType == "right") {
			if (
				const_var.wallsData["rightLean"]?.closedEndWalls == 0 &&
				const_var.wallsData["rightLean"]?.closedSideWalls == 0 &&
				const_var.wallsData["rightLean"]?.fullclosedEndWalls == 0 &&
				const_var.wallsData["rightLean"]?.fullclosedSideWalls == 0
			) {
				return false;
			} else {
				return true;
			}
		} else if (leanType == "front") {
			if (
				const_var.wallsData["frontLean"]?.closedEndWalls == 0 &&
				const_var.wallsData["frontLean"]?.closedSideWalls == 0 &&
				const_var.wallsData["frontLean"]?.fullclosedEndWalls == 0 &&
				const_var.wallsData["frontLean"]?.fullclosedSideWalls == 0
			) {
				return false;
			} else {
				return true;
			}
		} else if (leanType == "back") {
			if (
				const_var.wallsData["backLean"]?.closedEndWalls == 0 &&
				const_var.wallsData["backLean"]?.closedSideWalls == 0 &&
				const_var.wallsData["backLean"]?.fullclosedEndWalls == 0 &&
				const_var.wallsData["backLean"]?.fullclosedSideWalls == 0
			) {
				return false;
			} else {
				return true;
			}
		} else {
			if (
				const_var.wallsData["center"]?.closedEndWalls == 0 &&
				const_var.wallsData["center"]?.closedSideWalls == 0 &&
				const_var.wallsData["center"]?.fullclosedEndWalls == 0 &&
				const_var.wallsData["center"]?.fullclosedSideWalls == 0
			) {
				return false;
			} else {
				return true;
			}
		}
		return true;
	};

	return (
		<>
			{a_p_d_a?.extra_add_on?.map((val, index) => {
				if (!val) {
					return;
				}

				let valPro = const_var.extraAddOnItemsArray?.find((item) => item?.label == val?.label);
				let list = const_var.extraAddOnItemsArray;
				let isPriceBoxShow = true;

				let roofPitchValue = params.p_r_p + "/12";

				if (const_var.isLTBuilding) {
					const x = const_var.selectedLeanType === "" ? "centerBuilding" : const_var.selectedLeanType;

					if (x == "left") {
						roofPitchValue = params.b_l_t_r_p + "/12";
					}
					if (x == "right") {
						roofPitchValue = params.b_l_t_r_pR + "/12";
					}
					if (x == "front") {
						roofPitchValue = params.b_l_t_r_pF + "/12";
					}
					if (x == "back") {
						roofPitchValue = params.b_l_t_r_pB + "/12";
					}

					valPro = const_var.lNTBuildingData?.extraAddOnItemsArray?.[x]?.find((item) => item?.label && item.label.includes(roofPitchValue));
					list = const_var.lNTBuildingData?.extraAddOnItemsArray[x];
				}

				if (val.roof_pitch && val.roof_pitch != roofPitchValue /* || (list.length == 0) */) {
					return null;
				}
				if (const_var.isLTBuilding && const_var.selectedLeanType != "" && const_var.selectedLeanType != "centerBuilding" && val.name && val.name.toLowerCase().includes("lift")) {
					return null;
				}
				if (val.siding_orientation && val.siding_orientation != "" && val.siding_orientation != "both" && val.siding_orientation != params.wallOrientation) {
					return null;
				}
				if (val.siding_orientation && (val.siding_orientation == "" || val.siding_orientation == "both" || val.siding_orientation == params.wallOrientation) && val.is_always_checked == 2) {
					isPriceBoxShow = false;
				}
				let optionsFor = "center";
				if (const_var.isLTBuilding) {
					optionsFor = const_var.selectedLeanType == "" ? "center" : const_var.selectedLeanType;
				}
				let showOption = true;
				if (val?.name?.toLowerCase().includes("foam")) {
					showOption = checkForVisiblity();
					if (!showOption) {
						return null;
					}
				}
				return (
					// <div className="control-field-bar">
					//   <div className="control-field">
					<div className="row gutters-5">
						<div className="col control-field">
							<div className="check-group">
								<Checkbox
									checked={list.length > 0 && list[index] != undefined && list[index].is_checked != undefined ? list[index].is_checked : false}
									label={val.label + `${list.length > 0 && list[index] != undefined && list[index].is_disabled != undefined ? " (Included)" : ""}`}
									disabled={list?.[index]?.is_always_checked == 2 ? true : list.length > 0 && list[index] != undefined && list[index].is_disabled != undefined ? list[index].is_disabled : false}
									onChange={() => dispatch(extraItemsAction("on", "extraAddOnItems", val, index))}
								/>
								<OverlayTrigger
									trigger="hover"
									placement={window.innerWidth > 992 ? "left-start" : "bottom"}
									rootClose={true}
									overlay={
										<Popover className="popover-info popover-md">
											<Popover.Content>
												<div className="info-content">
													<p>This item is not shown on the configurator, but gets added to your building design and may increase the price</p>
												</div>
											</Popover.Content>
										</Popover>
									}
								>
									<span className="control-info-tip">
										<i class="icon-eye-off"></i>
									</span>
								</OverlayTrigger>
								{isPriceBoxShow && list.length > 0 && list[index] != undefined && list[index].is_checked != undefined && list[index].is_checked && isIncluded == false && (
									<div className={`control-field-action ${list[index].is_disabled != undefined && list[index].is_disabled ? "disabled" : ""}`}>
										{const_var.loginSession == true ? (
											<div className="price-box">
												<EditPriceItem
													is_disabled={valPro?.is_checked}
													jsonObj={"extraitems"}
													jsonObjValue={valPro?.is_checked}
													jsonObjKey={val.label}
													elementObjIndex={index}
													extraItemType={"additionalFeatures"}
													priceKey={"extraAddOnItemsArray"}
												/>
											</div>
										) : (
											<div className="price-box-type-2">
												{const_var.hide_price_calculation != 1 && elementPrice?.[val.label]?.item_price !== undefined && (
													<CurrencyFormat value={elementPrice[val.label]?.item_price} displayType={"text"} thousandSeparator={true} prefix={"$"} />
												)}
											</div>
										)}
									</div>
								)}
							</div>
						</div>
						<div className="col-auto text-right">
							{list?.[index]?.is_checked && list?.[index]?.is_checkbox && list?.[index]?.is_checkbox == 2 && (
								<Dropdown className="drop-default">
									<Dropdown.Toggle as={DropDefaultToggle}>
										<span className="text text-ellipsis mxw-100">{const_var.selLoftVal[optionsFor] + " Feet"}</span>
										<i className="icon icon-arrow-down-ico"></i>
									</Dropdown.Toggle>
									<Dropdown.Menu className="drop-menu-default" align="right">
										<ul className="drop-list-default">
											{Object.entries(const_var.loft_value_array[optionsFor]).map(([key, value]) => {
												return (
													<li className="drop-list-item">
														<div className="radio-group">
															<Radio onChange={(e) => onLoftChange(value, index, list?.[index]?.label)} checked={value == const_var.selLoftVal[optionsFor]} label={key} value={value} />
														</div>
													</li>
												);
											})}
										</ul>
									</Dropdown.Menu>
								</Dropdown>
							)}
						</div>
					</div>
				);
			})}
		</>
	);
};

export default ExtraItemsAddOn;
